import { cn } from "@gymflow/helpers";
import { useAuthenticatedUser } from "apps/portal/src/providers";
import hash from "object-hash";
import { useTranslation } from "react-i18next";
import { useLocalStorage } from "usehooks-ts";

import { AppStoreButton, CloseIcon, PlayStoreButton } from "../../../atoms";
import { getMobileOperatingSystem } from "../../../pages/Migration/MigrationSuccess";
import { HostedPagesProfileCard } from "../../components/HostedPagesProfileCard";

export const HostedPagesAppsBanner = () => {
  const { t } = useTranslation();

  const { id } = useAuthenticatedUser();

  const [isShowAppsBanner, setIsShowAppsBanner] = useLocalStorage<boolean>(
    `apps-banner-${hash(String(id))}`,
    true,
  );

  const system = getMobileOperatingSystem();
  const isDesktop = system !== "Android" && system !== "iOS";

  return (
    <HostedPagesProfileCard.Container
      className={cn("flex-col gap-4 p-4", { hidden: !isShowAppsBanner })}
    >
      <div className="flex flex-row items-center justify-between">
        <div className="dark:text-gray-25 text-sm font-semibold text-gray-950">
          {t("pages.hostedPagesAppsBanner.mobileAppAlsoAvailable")}
        </div>
        <div
          className="cursor-pointer"
          onClick={() => setIsShowAppsBanner(false)}
        >
          <CloseIcon
            className="size-4"
            pathClassName="stroke-gray-500 dark:stroke-gray-400"
          />
        </div>
      </div>
      <div className="flex flex-row gap-3">
        <PlayStoreButton
          className={cn("hidden w-full lg:w-fit", {
            flex: system === "Android" || isDesktop,
          })}
        />
        <AppStoreButton
          className={cn("hidden w-full lg:w-fit", {
            flex: system === "iOS" || isDesktop,
          })}
        />
      </div>
    </HostedPagesProfileCard.Container>
  );
};
